import React, { useEffect, useState, useRef } from "react";
import Intro from "./Intro";
import MetaTags from "react-meta-tags";
import Resources from "./Resources";
import { Helmet } from "react-helmet";
import { useHistory, Redirect } from "react-router-dom";

function Thankyou({ blogsData, licencingDetails }) {
  let history = useHistory();
  const [email] = useState(() => history.location.state?.email);
  const tracked = useRef(false);
  useEffect(() => {
    if (!email || tracked.current) return;
    tracked.current = true;
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "lead_form_submission",
      user_data: {
        email: email,
      },
    });

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-10781127278/YGggCOjxj8sbEO7k65Qo",
      });
    }
  }, [email, history]);
  if (!email) {
    return <Redirect to="/" />;
  }
  // useEffect(() => {
  //   if (!history.location.state?.email) return;
  //   window.dataLayer = window.dataLayer || [];

  //   window.dataLayer.push({
  //     event: "lead_form_submission",
  //     user_data: {
  //       email: history.location.state?.email,
  //     },
  //   });

  //   if (typeof window.gtag === "function") {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-10781127278/YGggCOjxj8sbEO7k65Qo",
  //     });
  //   }
  //   history.replace(history.location.pathname + history.location.search, {});
  // }, [history.location.state?.email]);
  return (
    <>
      {/* <MetaTags> */}
      <Helmet>
        <title>Thank you</title>
        <meta
          name="description"
          content="For more information or any query please contact us. Registered contact details along with Management information.
          "
        />
        <meta property="og:title" content="UpdaptCSR | Contact US" />
        <meta
          property="og:image"
          content="%PUBLIC_URL%/static/media/banner.jpg"
        />
        {/* </MetaTags> */}
        {/* <Helmet> */}
        {/* <!-- Google tag (gtag.js) --> */}
        {/* <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-MSXM84H570"
        ></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-MSXM84H570');
  gtag('event', 'conversion', {'send_to': 'AW-10781127278/YGggCOjxj8sbEO7k65Qo'});
  `}
        </script> */}
      </Helmet>
      <Intro></Intro>
      <Resources blogsData={blogsData}></Resources>
    </>
  );
}

export default Thankyou;
